export default __webpack_public_path__ + "static/media/icon_fondos.0928e673.svg";